import { addErrorHandler, getAppStatus, registerApplication, start, LOAD_ERROR } from 'single-spa';

// registerApplication({
//   name: '@single-spa/welcome',
//   app: () =>
//     System.import(
//       'https://unpkg.com/single-spa-welcome/dist/single-spa-welcome.js'
//     ),
//   activeWhen: ['/'],
// });

addErrorHandler(err => {
  if (getAppStatus(err.appOrParcelName) === LOAD_ERROR) {
    (window as any).handleCriticalLoadFailure(err);
  }
});

// Marketplace is the fallback route
// Both applications have fall back routes to display a 404 page.

registerApplication({
  name: '@vm/omega-product-application',
  app: () => System.import('@vm/omega-product-application'),
  activeWhen: [location => (window as any).pathnameStartsWithProductApplication(location.pathname) === true],
  customProps: {
    domElement: document.getElementById('single-spa-application:@vm/omega-product-application'),
  },
});

registerApplication({
  name: '@vm/omega-marketplace',
  app: () => System.import('@vm/omega-marketplace'),
  activeWhen: [location => (window as any).pathnameStartsWithProductApplication(location.pathname) === false],
  customProps: {
    domElement: document.getElementById('single-spa-application:@vm/omega-marketplace'),
  },
});

start({
  urlRerouteOnly: true,
});
